import React from 'react';
import PropTypes from 'prop-types';
import { isNil, join } from 'lodash';
import { Field } from 'formik';
import { MenuItem } from '@material-ui/core';
import { GridItem } from '../Grid';
import DropdownWrapper from './DropdownWrapper';
import TextFieldWrapper from './TextFieldWrapper';
import { PRESCRIPTION_ROUTE } from '../../../lib/dataLayer';

const ROUTE = 'routeId';

const DEFAULT_OPTIONS = [
  {
    value: 'day',
    label: 'day',
  },
  {
    value: 'hour',
    label: 'hour',
  },
  {
    value: 'week',
    label: 'week',
  },
  {
    value: 'month',
    label: 'month',
  },
];

function FrequencyForm({
  frequencyFieldName,
  min,
  unitsFieldName,
  options,
  paths,
  required,
}) {
  const inputProps = !isNil(min) ? { min } : {};
  return (
    <React.Fragment>
      <GridItem xs={12}>
        <Field
          component={DropdownWrapper}
          id={ROUTE}
          label="Route"
          name={join([...paths, ROUTE], '.')}
          paths={[...paths, ROUTE]}
        >
          <MenuItem value={PRESCRIPTION_ROUTE.ORAL.value}>
            {PRESCRIPTION_ROUTE.ORAL.label}
          </MenuItem>
          <MenuItem value={PRESCRIPTION_ROUTE.G_TUBE.value}>
            {PRESCRIPTION_ROUTE.G_TUBE.label}
          </MenuItem>
          <MenuItem value={PRESCRIPTION_ROUTE.J_TUBE.value}>
            {PRESCRIPTION_ROUTE.J_TUBE.label}
          </MenuItem>
          <MenuItem value={PRESCRIPTION_ROUTE.RECTAL.value}>
            {PRESCRIPTION_ROUTE.RECTAL.label}
          </MenuItem>
          <MenuItem value={PRESCRIPTION_ROUTE.IV.value}>
            {PRESCRIPTION_ROUTE.IV.label}
          </MenuItem>
          <MenuItem value={PRESCRIPTION_ROUTE.NG_TUBE.value}>
            {PRESCRIPTION_ROUTE.NG_TUBE.label}
          </MenuItem>
          <MenuItem value={PRESCRIPTION_ROUTE.TOPICAL.value}>
            {PRESCRIPTION_ROUTE.TOPICAL.label}
          </MenuItem>
          <MenuItem value={PRESCRIPTION_ROUTE.NEBULIZER.value}>
            {PRESCRIPTION_ROUTE.NEBULIZER.label}
          </MenuItem>
          <MenuItem value={PRESCRIPTION_ROUTE.OTHER.value}>
            {PRESCRIPTION_ROUTE.OTHER.label}
          </MenuItem>
        </Field>
      </GridItem>
      <GridItem lg={2} xs={6}>
        <Field
          component={TextFieldWrapper}
          id={frequencyFieldName}
          inputProps={inputProps}
          label="Frequency"
          name={join([...paths, frequencyFieldName], '.')}
          paths={[...paths, frequencyFieldName]}
          required={required}
          type="number"
        />
      </GridItem>
      <GridItem sm={1} xs={2}>
        per
      </GridItem>
      <GridItem lg={2} xs={4}>
        <Field
          component={DropdownWrapper}
          id={unitsFieldName}
          label="Interval"
          name={join([...paths, unitsFieldName], '.')}
          paths={[...paths, unitsFieldName]}
          required={required}
        >
          {options.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Field>
      </GridItem>
    </React.Fragment>
  );
}

FrequencyForm.propTypes = {
  frequencyFieldName: PropTypes.string.isRequired,
  unitsFieldName: PropTypes.string.isRequired,

  min: PropTypes.number,
  options: PropTypes.array,
  paths: PropTypes.array,
  required: PropTypes.bool,
};

FrequencyForm.defaultProps = {
  min: undefined,
  options: DEFAULT_OPTIONS,
  paths: [],
  required: false,
};

export default FrequencyForm;



// WEBPACK FOOTER //
// ./src/modules/common/form/FrequencyForm.js